import React from "react";
import { Link } from "react-router";
import { Instagram, Facebook, Youtube } from "lucide-react";

function LandingFooter() {
    const logo = (
        <img
            src={require('../../statics/img/VERDE-2.png')}
            alt="logo"
            className="h-7 md:h-8 w-auto object-contain mr-2 transition-all"
        />
    );

    return (
        <footer className="py-12 px-4 md:px-8 mt-auto text-left bg-[#08090C] border-t border-[#1A1D24]">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-6 justify-between">
                {/* Column 1: Logo & Social */}
                <div className="lg:col-span-4 flex flex-col gap-3">
                    <div className="self-start">{logo}</div>
                    <p className="m-0 max-w-xs text-sm text-urb-text-secondary leading-relaxed">
                        A plataforma de eventos esportivos e running experience do Brasil.
                    </p>
                    <div className="flex gap-2.5 mt-3">
                        <button 
                            type="button"
                            aria-label="Instagram"
                            className="w-9 h-9 rounded-full bg-urb-card-light/80 border border-urb-border flex items-center justify-center text-urb-text-secondary hover:text-urb-primary hover:border-urb-primary transition-all cursor-pointer"
                        >
                            <Instagram className="w-4 h-4" />
                        </button>
                        <button 
                            type="button"
                            aria-label="Facebook"
                            className="w-9 h-9 rounded-full bg-urb-card-light/80 border border-urb-border flex items-center justify-center text-urb-text-secondary hover:text-urb-primary hover:border-urb-primary transition-all cursor-pointer"
                        >
                            <Facebook className="w-4 h-4" />
                        </button>
                        <button 
                            type="button"
                            aria-label="Youtube"
                            className="w-9 h-9 rounded-full bg-urb-card-light/80 border border-urb-border flex items-center justify-center text-urb-text-secondary hover:text-urb-primary hover:border-urb-primary transition-all cursor-pointer"
                        >
                            <Youtube className="w-4 h-4" />
                        </button>
                    </div>
                </div>

                {/* Column 2: Eventos */}
                <div className="col-span-1 sm:col-span-1 lg:col-span-2 flex flex-col gap-2.5">
                    <h4 className="text-xs font-bold uppercase tracking-wider text-urb-primary">EVENTOS</h4>
                    <Link to="/" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Próximos Eventos</Link>
                    <Link to="/" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Calendário de Eventos</Link>
                </div>

                {/* Column 3: Para Atletas */}
                <div className="col-span-1 sm:col-span-1 lg:col-span-2 flex flex-col gap-2.5">
                    <h4 className="text-xs font-bold uppercase tracking-wider text-urb-primary">PARA ATLETAS</h4>
                    <Link to="/como-funciona" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Como Funciona</Link>
                    <Link to="/novas-corridas" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Inscrições</Link>
                    <Link to="/minhas-corridas" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Resultados</Link>
                    <Link to="/politica-privacidade" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Política de Privacidade</Link>
                </div>

                {/* Column 4: Para Organizadores */}
                <div className="col-span-1 sm:col-span-1 lg:col-span-2 flex flex-col gap-2.5">
                    <h4 className="text-xs font-bold uppercase tracking-wider text-urb-primary">PARA ORGANIZADORES</h4>
                    <Link to="/para-organizadores" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Crie seu Evento</Link>
                    <Link to="/dashboard" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Painel do Organizador</Link>
                    <Link to="/recursos" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Recursos</Link>
                    <Link to="/contato" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Suporte</Link>
                </div>

                {/* Column 5: Ajuda */}
                <div className="col-span-1 sm:col-span-1 lg:col-span-2 flex flex-col gap-2.5">
                    <h4 className="text-xs font-bold uppercase tracking-wider text-urb-primary">AJUDA</h4>
                    <Link to="/contato" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Central de Ajuda</Link>
                    <Link to="/contato" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Fale Conosco</Link>
                    <Link to="/termos-servico" className="text-sm text-urb-text-secondary hover:text-white transition-colors">Termos de Uso</Link>
                </div>
            </div>

            <hr className="my-8 w-full border-t border-[#1A1D24]" />

            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-urb-text-muted">
                <span>© 2025 URB RACE - Todos os direitos reservados.</span>
                <div className="flex gap-4">
                    <Link to="/politica-privacidade" className="hover:text-white transition-colors">Privacidade</Link>
                    <Link to="/termos-servico" className="hover:text-white transition-colors">Termos</Link>
                    <Link to="/termos-servico" className="hover:text-white transition-colors">Responsabilidade</Link>
                </div>
            </div>
        </footer>
    );
}

export default LandingFooter;
